import React from "react";
import WebPImage from "../components/images/web.png";
import TutorImg from "../components/images/tutor.png";
import WriterImg from "../components/images/writer.png";

const Card = ({ image, title, writeUp }) => {
  return (
    <div
      className="min-h-[15rem] w-[22rem] mx-2 max-xl:my-2 glassy bg-[rgba(0,0,0,0.6)] p-3 rounded-xl shadow-2xl"
      data-aos="flip-left"
      data-aos-duration="1000"
    >
      <img src={image} alt="" className="h-[6rem]" />
      <h1 className="mb-3 font-[700] text-[1.1rem]">{title}</h1>
      <p className="mb-2">{writeUp}</p>
      <a
        href="mailto: abrahamcovenant2004@gmail.com"
        className="bg-blue-700 py-1 px-5 text-white rounded-sm border-none font-[300] my-2"
      >
        HIRE ME
      </a>
    </div>
  );
};
const Services = () => {
  return (
    <section className="mt-[9rem] w-full pb-5" id="Services">
      <div className="max-w-6xl  text-gray-400 px-4 mx-auto">
        <h1
          className="font-[200] text-[3rem] max-sm:text-[2rem] px-2 xl:text-left text-center"
          data-aos="slide-up"
          data-aos-duration="1000"
        >
          WHAT I DO
        </h1>
        <section className="flex flex-wrap justify-center items-center">
          <Card
            image={WebPImage}
            title="WEB DEVELOPMENT"
            writeUp="I'm professionally equipped with a good foundation in web development for creation of responsive and user friendly UI let me get you a site!"
          />
          <Card
            image={TutorImg}
            title="TUTORING"
            writeUp="If you actually have the passion for web development but don't know how to start and you want to have a private tutor, i'm available."
          />
          <Card
            image={WriterImg}
            title="CONTENT WRITING"
            writeUp="I basically possess writing skills to enable me display my thoughts on a particular subject based on acquired knowledge to educate people."
          />
        </section>
      </div>
    </section>
  );
};

export default Services;
